import React, { useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import Card from "../Card";
import "./single.scss";
import { getStorageItem } from "../../utils/sessionStorage";
import { toast } from "react-toastify";
import axios from "axios";
import { Helmet } from "react-helmet";
import BuyCartButton from "../../components/buy-cart-button";
import VerifiedIcon from "@mui/icons-material/Verified";
import { AiOutlineCopy } from "react-icons/ai";
import { CartContext } from "../../context/CartContext";

const Index = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);
  const [products, setProducts] = useState([]);
  const [sellerDetail, setSellerDetail] = useState(null);
  // const [buyerCheckSeller, setBuyerCheckSeller] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);
  const userId = getStorageItem("user_id");
  const userName = getStorageItem("full_name");
  const userAvatar =
    getStorageItem("avatar") ||
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460__340.png";
  const userEmail = getStorageItem("user_email");
  const accessToken = getStorageItem("token");
  const [modal, setModal] = useState(false);
  const [cart, setCart] = useContext(CartContext);
  const [isProductPresent, setIsProductPresent] = useState(false);
  const navigate = useNavigate();

  const closePopup = () => {
    setModal(false);
    document.body.style.overflow = "auto";
  };

  const openPopup = () => {
    setModal(true);
    document.body.style.overflow = "hidden";
    window.scrollTo(0, 0); // scroll to top left corner of viewport
  };

  // Function to get products using categories
  async function fetchProductsByCategories() {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
        `/marketplace/product/getProductsByCategory/${product?.category}?limit=5`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const { products, count } = await response.json();
      const suggested = products?.filter((item) => {
        return item._id !== id;
      });
      setProducts(suggested);
    } catch (err) {
      console.log(err);
    }
  }

  // Function to calculate final product price after discount
  const calculateDiscount = (price, discountPrice) => {
    return Math.round(price - discountPrice);
  };

  // Function to calculate time
  const convertDate = (date) => {
    // Format the createdAt date using the formatDate function
    const formattedDate = moment(date).format("DD/MM/YYYY");
    return formattedDate;
  };

  // Function to fetch product
  const fetchProduct = async () => {
    try {
      const response = await fetch(
        global.config.ROOTURL.prod +
        `/marketplace/product/getSingleProductByProductId/${id}`,
        {
          headers: {
            Authorization: "Bearer " + accessToken,
            "Content-Type": "application/json",
          },
        }
      );
      const product = await response.json();
      handleCheckSeller(product?.sellerId);
      setProduct(product);
      if (cart.length > 0) {
        const productFound = cart.find((item) => {
          return item?.productInfo?._id === product?._id;
        });
        if (productFound) {
          setIsProductPresent(true);
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  // Function to fetch seller details
  const handleCheckSeller = async (sellerId) => {
    if (!sellerId && !accessToken) return
    const opt = {
      method: "GET",
      url:
        global.config.ROOTURL.prod +
        `/marketplace/seller/findInformationOfSingleSellerById/${sellerId}`,
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };
    axios(opt)
      .then((data) => {
        setSellerDetail(data?.data);
        closePopup();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleAddToCart = async (product) => {
    if (!product) return;
    const productSellerInfo = {
      productInfo: product,
      sellerInfo: sellerDetail,
    };
    productSellerInfo.productInfo.quantity = 1;
    setCart([...cart, productSellerInfo]);
    localStorage.setItem("cart", JSON.stringify([...cart, productSellerInfo]));
    toast.success(`${product?.title} added to cart`);
  };

  // Function to check if buyer have already checked seller
  // const checkIfBuyerAlreadyCheckedTheSeller = async () => {
  //   try {
  //     const response = await fetch(
  //       global.config.ROOTURL.prod + `/marketplace/buyer/findProductCheckedByBuyerEmail/${userEmail}/${id}`,
  //       {
  //         headers: {
  //           Authorization: "Bearer " + accessToken,
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     const result = await response.json();
  //     if (result !== null) {
  //       setBuyerCheckSeller(true);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // Function to create Buyer
  const handleCreateBuyer = async () => {
    // Check seller check eligibility
    if (!userId && !accessToken) return
    try {
      const options = {
        method: "GET",
        url: global.config.ROOTURL.prod + "/pitch/getTotalRun/" + userId,
        headers: {
          Authorization: "Bearer " + accessToken,
        },
      };
      axios(options)
        .then((data) => {
          if (data.data >= product?.runs) {
            // Create a new buyer
            if (!localStorage.getItem("buyer-address")) {
              toast.error("Buyer Address does not exists");
              navigate("/marketplace/address");
              return;
            }
            const address = JSON.parse(localStorage.getItem("buyer-address"));
            const buyerInformationData = {
              buyerId: userId,
              buyerName: userName,
              buyerEmail: userEmail,
              buyerProfile: userAvatar,
              productId: product?._id,
              buyerAddress: address,
              sellerId: product?.sellerId,
            };
            const opt = {
              method: "POST",
              url:
                global.config.ROOTURL.prod + `/marketplace/buyer/createBuyer`,
              headers: {
                Authorization: "Bearer " + accessToken,
                "Content-Type": "application/json",
              },
              data: buyerInformationData,
            };
            axios(opt)
              .then((data) => {
                navigate(`/marketplace/order_status/${userId}`);
              })
              .catch((error) => {
                console.log(error);
              });
          } else {
            toast.error("You are not eligible to buy this product");
            return;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [id]);
  useEffect(() => {
    fetchProductsByCategories();
  }, [product]);
  // useEffect(() => {
  //   checkIfBuyerAlreadyCheckedTheSeller();
  // }, [product, sellerDetail]);

  useEffect(() => {
    // Login to check if the product exists in cart or not
    if (cart.length > 0) {
      const productFound = cart.find((item) => {
        return item?.productInfo?._id === product?._id;
      });
      if (productFound) {
        setIsProductPresent(true);
      }
    }
  }, [cart]);

  return (
    <div className="single__main">
      <Helmet>
        <title>Champhunt | MarketPlace-${id}</title>
      </Helmet>
      {/* Modal */}
      {modal && (
        <div className="confirm__modal">
          <div className="seller__details-box">
            <img
              src="/marketplace/cancel.svg"
              alt="cancel"
              className="cancel"
              onClick={closePopup}
            />
            <h3 className="confirm__modal-heading">Contact Seller</h3>
            {product?.contactPhone && (
              <div className="seller__details">
                <img
                  src="/marketplace/phone.svg"
                  alt="phone"
                  className="details"
                />
                <h4 className="seller-contact-details">
                  {product?.contactPhone}
                </h4>
                <AiOutlineCopy
                  className="icon--copy"
                  onClick={() => {
                    navigator.clipboard.writeText(product?.contactPhone);
                    toast.success("Phone number copied.");
                  }}
                />
              </div>
            )}
            {product?.contactWhatsapp && (
              <div className="seller__details">
                <img
                  src="/marketplace/whatsapp.svg"
                  alt="whatsapp"
                  className="details"
                />
                <h4 className="seller-contact-details">
                  {product?.contactWhatsapp}
                </h4>
                <AiOutlineCopy
                  className="icon--copy"
                  onClick={() => {
                    navigator.clipboard.writeText(product?.contactWhatsapp);
                    toast.success("Whatsapp number copied.");
                  }}
                />
              </div>
            )}
            {product?.contactEmail && (
              <div className="seller__details">
                <img
                  src="/marketplace/email.svg"
                  alt="email"
                  className="details"
                />
                <h4 className="seller-contact-details">
                  {product?.contactEmail}
                </h4>
                <AiOutlineCopy
                  className="icon--copy"
                  onClick={() => {
                    navigator.clipboard.writeText(product?.contactEmail);
                    toast.success("Email copied.");
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
      {/* Banner */}
      <div className="main__banner">
        <div className="product__banner">
          {product?.images?.length > 0 && (
            <div className="symbols__wrapper">
              {product?.images?.map((image, index) => {
                return (
                  <div
                    key={index}
                    className={
                      imageIndex === index ? "symbols-elongated" : "symbols"
                    }
                    onClick={() => {
                      setImageIndex(index);
                    }}
                  ></div>
                );
              })}
            </div>
          )}
          {product?.images?.length > 0 && (
            <div className="part-1">
              {product?.images?.map((image, index) => {
                return (
                  <div
                    key={index}
                    className="box-1"
                    onClick={() => {
                      setImageIndex(index);
                    }}
                  >
                    <img src={image} alt="product" />
                  </div>
                );
              })}
            </div>
          )}
          <div className="part-2">
            <img
              src={product?.images ? product.images[imageIndex] : ""}
              alt="product"
            />
          </div>
        </div>
      </div>
      {/* Description */}
      <div className="product__description">
        <div className="product__wrapper">
          <div className="product--first_box--single">
            <div className="product__flex">
              <div className="product__box--single_product">
                <h3 className="product__title">{product?.title}</h3>
                <h4 className="product__category">{product?.category}</h4>
                <div className="product__price">
                  <div className="price__box">
                    {product?.discount > 0 && (
                      <>
                        <h4 className="product__discount">
                          -
                          {Math.round(
                            (product?.discount / product?.price) * 100
                          )}
                          %
                        </h4>
                        <h4 className="product__real-price">
                          ₹ {product?.price}
                        </h4>
                      </>
                    )}
                    <h4 className="product__total-price">
                      ₹ {calculateDiscount(product?.price, product?.discount)}
                    </h4>
                  </div>
                  {/* <div className="date__box">
              <h4 className="product__date">
                {convertDate(product?.createdAt)}
              </h4>
            </div> */}
                </div>
              </div>
              <div className="share__box--single_product">
                <div>
                  <img
                    src="/marketplace/share.svg"
                    alt="share-details"
                    className="share-details"
                  />
                </div>
                <div className="product__stock">
                  {product?.stock > 0 ? "In Stock" : "Out of Stock"}
                </div>
              </div>
            </div>
            {product?.stock > 0 ? (
              <div className="buy__button--single-product">
                <button
                  className="product__button--buy"
                  onClick={handleCreateBuyer}
                >
                  Buy for {product?.runs} Runs
                </button>
              </div>
            ) : (
              <div className="buy__button--single-product-oos">
                <button className="product__button--buy">Out of Stock</button>
              </div>
            )}
          </div>
          <div className="product__button seller__box">
            <div>
              <div className="seller__detail-headings">
                <p className="seller__detail-name">Listed By</p>
                <h4 className="seller__listing-time">
                  {moment(product?.createdDate).format("DD/MM/YYYY")}
                </h4>
              </div>
              <div className="user__section">
                <div className="user">
                  <img
                    src={sellerDetail?.sellerProfile}
                    alt="user-profile"
                    className="profile"
                  />
                  <h4 className="user-name">{sellerDetail?.sellerName}</h4>
                  {sellerDetail?.isSellerVerified && (
                    <VerifiedIcon style={{ color: "#FEBC3C" }} />
                  )}
                </div>
                <div className="seller-contact__button" onClick={openPopup}>
                  Contact
                </div>
              </div>
              {product?.sellerId === userId ? (
                <p className="seller__text--hidden">
                  <span className="seller__detail-headings">Total checks:</span>{" "}
                  {product?.sellerCheckCount}
                </p>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="product__description">
            <h4 className="description__title">Description</h4>
            <p className="description__text">{product?.description}</p>
          </div>
          {/* Check if the buyer already checked the details */}
          {/* {sellerDetail?.sellerEmail === userEmail || buyerCheckSeller ? (
            <div className="product__button seller__box">
              <div>
                <p className="seller__detail-headings">Contact</p>
                <div className="user__section">
                  <h4>Listed by</h4>
                  <div className="user">
                    <img
                      src={sellerDetail?.sellerProfile}
                      alt="user-profile"
                      className="profile"
                    />
                    <h4 className="user-name">{sellerDetail?.sellerName}</h4>
                  </div>
                </div>
                <div className="seller__details">
                  {showPhone ? (
                    <a href={phoneNumberLink} target="_blank" rel="noreferrer">
                      <img
                        src="/marketplace/phone.svg"
                        alt="phone"
                        className="details"
                      />
                    </a>
                  ) : (
                    ""
                  )}
                  {showWhatsapp ? (
                    <a
                      href={whatsappNumberLink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src="/marketplace/whatsapp.svg"
                        alt="whatsapp"
                        className="details"
                      />
                    </a>
                  ) : (
                    ""
                  )}
                  {showEmail ? (
                    <a href={emailLink} target="_blank" rel="noreferrer">
                      <img
                        src="/marketplace/email.svg"
                        alt="email"
                        className="details"
                      />
                    </a>
                  ) : (
                    ""
                  )}
                </div>
                {product?.sellerId === userId ? (
                  <p className="seller__text--hidden">
                    <span className="seller__detail-headings">
                      Total checks:
                    </span>{" "}
                    {product?.sellerCheckCount}
                  </p>
                ) : (
                  ""
                )}
              </div>
            </div>
          ) : (
            <div className="product__button">
              <img src="/marketplace/runs.svg" alt="runs" className="runs" />
              <button onClick={openPopup}>Contact Seller</button>
              <p className="bold__text">50 Runs</p>
              <p>to Contact the Seller</p>
            </div>
          )} */}
          {product?.stock > 0 ? (
            <div className="buy-cart--buttons">
              <div onClick={handleCreateBuyer}>
                <BuyCartButton type="buy-now" />
              </div>
              {isProductPresent ? (
                <div
                  onClick={() => {
                    if (isProductPresent) {
                      return;
                    }
                    handleAddToCart(product);
                  }}
                >
                  <BuyCartButton
                    type="add-to-cart"
                    isProductPresent={isProductPresent}
                  />
                </div>
              ) : (
                <div
                  onClick={() => {
                    if (isProductPresent) {
                      return;
                    }
                    handleAddToCart(product);
                  }}
                >
                  <BuyCartButton type="add-to-cart" />
                </div>
              )}
            </div>
          ) : (
            <div className="buy-cart--buttons">
              <BuyCartButton type="notify-me" productId={product?._id} />
            </div>
          )}
        </div>
      </div>
      {/* Suggestions */}
      <div className="product__suggestions">
        {products?.length > 0 && <h4 className="suggestions">Suggestions</h4>}
        <div className="product__group">
          {products?.map((item, index) => {
            return <Card product={item} index={index} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Index;
